import React, { FC } from "react";
import { ModalProps } from "../../../helpers/constants";
import Modal from "../../common/form/Modal";
import ButtonTray from "../../common/form/ButtonTray";

interface ConfirmationModalProps extends ModalProps {
    title: string;
    bodyMessage: any;
    onSubmit?: any;
    cancelBtnTxt?: string;
    confirmBtnTxt?: string;
    isLoading?: boolean;
    note?: any;
    setNote?: any;
    isHoa?: boolean;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
    show,
    setShow,
    title = "",
    bodyMessage = "",
    onSubmit,
    cancelBtnTxt = "Cancel",
    confirmBtnTxt = "Confirm",
    isLoading = false,
    note = "",
    setNote = "",
    isHoa
}) => {
    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/6 bg-text-0 text-surface-0"}
            hoa={isHoa}
            fields={
                <>
                    {/* Body Content */}
                    <div>
                        <h3 className="mb-5 text-base font-normal text-surface-0">{bodyMessage}</h3>
                    </div>

                    {/* Divider */}


                    {/* Footer with Buttons */}
                    <div className="mt-4 border-t border-t-surface-5 flex justify-end">
                        {title !== 'Alert' ? (
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: cancelBtnTxt,
                                            onClick: () => setShow(false),
                                            type: "cancel",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: confirmBtnTxt,
                                            onClick: async (e: any) => {
                                                e.preventDefault();
                                                await onSubmit(e);
                                                setShow(false);
                                            },
                                            type: "submit",
                                            isLoading: isLoading,
                                            isHoa: isHoa
                                        },
                                        buttonType: "button"
                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />
                        ) : (
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "OK",
                                            onClick: async (e: any) => {
                                                e.preventDefault();
                                                if (onSubmit) {
                                                    await onSubmit(e);
                                                }
                                                setShow(false);
                                            },
                                            type: "submit",
                                            isHoa: isHoa
                                        },
                                        buttonType: "button"
                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />
                        )}
                    </div>
                </>
            }
        />
    );
};

export default ConfirmationModal;
